define("settings/templates/groups/index", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="o--container tAC--container">
    <Shared::Card class="tAC--card" as |card|>
      {{! Header }}
      <card.header @title={{t "account.groups.title"}} @titleClass="tAC--header__title" />
      {{! Body }}
      <card.body>
        {{! Actions }}
        {{#if this.isAccountOwner}}
          <Section class="tAC--section__item u--m__b__lg" as |section|>
            <section.details>
              <p class="u--text--md u--m__0 u--p__r">{{t "account.groups.organize_description"}}</p>
              <p class="u--text--light u--m__tb__xs">
                {{t "shared_phrases.social_sets_left" remaining=this.socialSetsRemaining total=this.totalSocialSets}}
              </p>
              <SocialSetUpgrade @socialSetsRemaining={{this.socialSetsRemaining}} />
            </section.details>
            <section.action>
              {{#if this.canCreateNewGroup}}
                <LinkTo
                  @route="groups.new"
                  class="o--btn o--btn--block o--btn--primary qa--settings__createAccessGroupBtn"
                >
                  {{t "account.groups.create_group_button"}}
                </LinkTo>
              {{else}}
                {{#unless this.isMobileSubscription}}
                  {{#if this.shouldShowSourcelessTrialConfirmation}}
                    <Shared::Ui::Button
                      @additional="block"
                      @onClick={{set this "showSourcelessTrialConfirmationModal" true}}
                      @text={{t "shared_phrases.upgrade_trial"}}
                      @variant="proceed"
                    />
                  {{else}}
                    <Shared::Button::Upgrade
                      @additional="block"
                      @feature="groups"
                      @location="account groups"
                      @text={{t "account.groups.upgrade"}}
                    />
                  {{/if}}
                {{/unless}}
              {{/if}}
              <LinkTo
                @route="groups.trade"
                class="o--btn o--btn--block o--btn--outline qa--settings__organizeSocialProfiles"
              >
                {{t "account.groups.organize_button"}}
              </LinkTo>
            </section.action>
          </Section>
        {{/if}}
  
        {{! New Table }}
        <table class="o--table tAC--table">
          {{! Table Head }}
          <thead>
            <tr>
              <th class="qa--settings__accessGroupTitle" style="width:165px;">{{t "account.groups.table.group_name"}}</th>
              <th class="qa--settings__socialSetTitle">
                {{t "account.groups.table.social_identities"}}
                <span {{on "click" (toggle-action "showInfo" this)}}>
                  {{svg-jar "info" class="o--icon--xs"}}
                </span>
              </th>
              <th style="width:125px;"></th>
            </tr>
          </thead>
          {{! Table Body }}
          <tbody>
            {{#each this.sortedGroups as |group|}}
              <Groups::GroupCover @editable={{false}} @group={{group}} @isFirstGroup={{eq group this.firstGroup}} />
            {{/each}}
          </tbody>
        </table>
  
        {{#if this.rolloutMetaMarketingApi}}
          <MetaMarketingApi />
        {{/if}}
      </card.body>
    </Shared::Card>
  </div>
  
  {{#if this.showInfo}}
    <Shared::SocialIdentity::Info @handleClose={{toggle-action "showInfo" this}} />
  {{/if}}
  
  {{#if this.showSourcelessTrialConfirmationModal}}
    <Shared::SourcelessTrial::ConfirmationModal
      @closeModal={{set this "showSourcelessTrialConfirmationModal" false}}
      @plan={{this.getGrowthPlan}}
    />
  {{/if}}
  */
  {
    "id": "qmtZnUE2",
    "block": "[[[10,0],[14,0,\"o--container tAC--container\"],[12],[1,\"\\n  \"],[8,[39,0],[[24,0,\"tAC--card\"]],null,[[\"default\"],[[[[1,\"\\n\"],[1,\"    \"],[8,[30,1,[\"header\"]],null,[[\"@title\",\"@titleClass\"],[[28,[37,1],[\"account.groups.title\"],null],\"tAC--header__title\"]],null],[1,\"\\n\"],[1,\"    \"],[8,[30,1,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isAccountOwner\"]],[[[1,\"        \"],[8,[39,3],[[24,0,\"tAC--section__item u--m__b__lg\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[8,[30,2,[\"details\"]],null,null,[[\"default\"],[[[[1,\"\\n            \"],[10,2],[14,0,\"u--text--md u--m__0 u--p__r\"],[12],[1,[28,[35,1],[\"account.groups.organize_description\"],null]],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--light u--m__tb__xs\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"shared_phrases.social_sets_left\"],[[\"remaining\",\"total\"],[[30,0,[\"socialSetsRemaining\"]],[30,0,[\"totalSocialSets\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,4],null,[[\"@socialSetsRemaining\"],[[30,0,[\"socialSetsRemaining\"]]]],null],[1,\"\\n          \"]],[]]]]],[1,\"\\n          \"],[8,[30,2,[\"action\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"canCreateNewGroup\"]],[[[1,\"              \"],[8,[39,5],[[24,0,\"o--btn o--btn--block o--btn--primary qa--settings__createAccessGroupBtn\"]],[[\"@route\"],[\"groups.new\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,1],[\"account.groups.create_group_button\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"]],[]],[[[41,[51,[30,0,[\"isMobileSubscription\"]]],[[[41,[30,0,[\"shouldShowSourcelessTrialConfirmation\"]],[[[1,\"                  \"],[8,[39,7],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,8],[[30,0],\"showSourcelessTrialConfirmationModal\",true],null],[28,[37,1],[\"shared_phrases.upgrade_trial\"],null],\"proceed\"]],null],[1,\"\\n\"]],[]],[[[1,\"                  \"],[8,[39,9],null,[[\"@additional\",\"@feature\",\"@location\",\"@text\"],[\"block\",\"groups\",\"account groups\",[28,[37,1],[\"account.groups.upgrade\"],null]]],null],[1,\"\\n\"]],[]]]],[]],null]],[]]],[1,\"            \"],[8,[39,5],[[24,0,\"o--btn o--btn--block o--btn--outline qa--settings__organizeSocialProfiles\"]],[[\"@route\"],[\"groups.trade\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,1],[\"account.groups.organize_button\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[2]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"      \"],[10,\"table\"],[14,0,\"o--table tAC--table\"],[12],[1,\"\\n\"],[1,\"        \"],[10,\"thead\"],[12],[1,\"\\n          \"],[10,\"tr\"],[12],[1,\"\\n            \"],[10,\"th\"],[14,0,\"qa--settings__accessGroupTitle\"],[14,5,\"width:165px;\"],[12],[1,[28,[35,1],[\"account.groups.table.group_name\"],null]],[13],[1,\"\\n            \"],[10,\"th\"],[14,0,\"qa--settings__socialSetTitle\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"account.groups.table.social_identities\"],null]],[1,\"\\n              \"],[11,1],[4,[38,10],[\"click\",[28,[37,11],[\"showInfo\",[30,0]],null]],null],[12],[1,\"\\n                \"],[1,[28,[35,12],[\"info\"],[[\"class\"],[\"o--icon--xs\"]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"th\"],[14,5,\"width:125px;\"],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,14],[[28,[37,14],[[30,0,[\"sortedGroups\"]]],null]],null],null,[[[1,\"            \"],[8,[39,15],null,[[\"@editable\",\"@group\",\"@isFirstGroup\"],[false,[30,3],[28,[37,16],[[30,3],[30,0,[\"firstGroup\"]]],null]]],null],[1,\"\\n\"]],[3]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"rolloutMetaMarketingApi\"]],[[[1,\"        \"],[8,[39,17],null,null,null],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showInfo\"]],[[[1,\"  \"],[8,[39,18],null,[[\"@handleClose\"],[[28,[37,11],[\"showInfo\",[30,0]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showSourcelessTrialConfirmationModal\"]],[[[1,\"  \"],[8,[39,19],null,[[\"@closeModal\",\"@plan\"],[[28,[37,8],[[30,0],\"showSourcelessTrialConfirmationModal\",false],null],[30,0,[\"getGrowthPlan\"]]]],null],[1,\"\\n\"]],[]],null]],[\"card\",\"section\",\"group\"],false,[\"shared/card\",\"t\",\"if\",\"section\",\"social-set-upgrade\",\"link-to\",\"unless\",\"shared/ui/button\",\"set\",\"shared/button/upgrade\",\"on\",\"toggle-action\",\"svg-jar\",\"each\",\"-track-array\",\"groups/group-cover\",\"eq\",\"meta-marketing-api\",\"shared/social-identity/info\",\"shared/sourceless-trial/confirmation-modal\"]]",
    "moduleName": "settings/templates/groups/index.hbs",
    "isStrictMode": false
  });
});